import { isApiError } from "@profitlens/api-client";
import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // 4xx is a business outcome, not a transport hiccup: never retry it.
          if (isApiError(error)) {
            if (error.isNetwork) return failureCount < 2;
            return error.status >= 500 && failureCount < 2;
          }
          return failureCount < 1;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
